import { z } from 'zod';
import { ReadingLevelSchema, WritingLevelSchema } from './reading-levels.js';
/**
 * Student schema - a participant in a study group
 */
export const StudentSchema = z.object({
    id: z.string(),
    name: z.string().min(1),
    readingLevel: ReadingLevelSchema,
    writingLevel: WritingLevelSchema,
});
/**
 * Options for creating a new student
 */
export const StudentAddOptionsSchema = z.object({
    name: z.string().min(1),
    readingLevel: ReadingLevelSchema,
    writingLevel: WritingLevelSchema,
});
/**
 * Options for updating an existing student
 */
export const StudentUpdateOptionsSchema = z.object({
    id: z.string(),
    name: z.string().min(1).optional(),
    readingLevel: ReadingLevelSchema.optional(),
    writingLevel: WritingLevelSchema.optional(),
});
//# sourceMappingURL=student.js.map